import React from "react";
import LoadingSpinner from "../LoadingSpinner";
import eventAnalytics from "../../analytikaV2";
import { ANALYTIKA_EVENTS } from "../../utils/constants";
import { verifyCorporateToken } from "./verifyCorporateToken";
import {
  CorporateContainer,
  CorporateLogo,
  CorporateFooter,
} from "./CorporateTemplate";

const PAGE_NAME = ANALYTIKA_EVENTS.PAGE.CORPORATE_EMAIL_VERIFICATION;

export default class CorporateEmailVerification extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isValidToken: false,
      loading: true,
    };
  }

  componentDidMount() {
    document.title = "Corporate | Careem";
    eventAnalytics.publishViewPage(PAGE_NAME);
    const token = this.props.match.params.token;
    const endpoint = `${process.env.REACT_APP_IDENTITY_SERVICES_SAG_HOST}/v1/verify/email/${token}`;
    verifyCorporateToken(endpoint, PAGE_NAME).then((isValidToken) => {
      this.setState({ isValidToken, loading: false });
    });
  }
  render() {
    if (this.state.loading) {
      return <LoadingSpinner />;
    } else if (this.state.isValidToken) {
      return (
        <CorporateContainer>
          <CorporateLogo />
          <div style={{ padding: "30px 20px", backgroundColor: "#FFFFFF" }}>
            <p style={{ textAlign: "center" }}>
              <strong>Your email has been verified successfully !</strong>
            </p>
            <p style={{ textAlign: "center" }}>Regards,</p>
            <p style={{ textAlign: "center" }}>Team Careem</p>
            <CorporateFooter />
          </div>
        </CorporateContainer>
      );
    } else {
      return (
        <CorporateContainer>
          <CorporateLogo />
          <div style={{ padding: "30px 20px", backgroundColor: "#FFFFFF" }}>
            <p style={{ textAlign: "center" }}>
              <strong>
                We couldn't verify your email. Please contact careem customer
                service.
              </strong>
            </p>
            <CorporateFooter />
          </div>
        </CorporateContainer>
      );
    }
  }
}
